import React, { lazy, Suspense } from 'react';
import Loader from '../../../components/Loader/Loader.lazy';

const LazySignOut = lazy(() => import('./SignOut'));

const SignOut = (props) => (
  <Suspense fallback={<Loader />}>
    <LazySignOut {...props} />
  </Suspense>
);

export default SignOut;
